module.exports = __webpack_public_path__ + "img/header.0dc6637f.png";